import { GlobalEvents } from '@highlight/ipc'
import { MEETING_VIEW_ID } from '@renderer/overlay/Sidepanel/components/meeting/meeting-view-id'
import { openViewWindow } from '@renderer/overlay/Sidepanel/open-view-window'
import { isSidepanelOverlay } from '@renderer/overlay/Sidepanel/surface'
import type { ViewContexts, ViewId } from '@renderer/overlay/Sidepanel/view-definitions'
import type { ArtifactType } from './artifact-url'

export type OpenableArtifactType = ArtifactType | 'staged-action'

type ArtifactView = { [K in ViewId]: { id: K; context: ViewContexts[K] } }[ViewId]

function artifactView(type: OpenableArtifactType, id: string): ArtifactView {
  switch (type) {
    case 'conversation':
      return { id: 'chat', context: { chatId: id } }
    case 'audio-note':
      return { id: MEETING_VIEW_ID, context: { mode: 'note', audioNoteId: id } }
    // Insights have no view of their own; the Action View is the closest equivalent.
    case 'insight':
    case 'staged-action':
      return { id: 'action', context: { actionId: id } }
  }
}

/**
 * Opens an internal record in its own popout window, or focuses the one already
 * showing it. Inside the overlay sidepanel the record opens in the panel instead.
 */
export function openArtifact(type: OpenableArtifactType, id: string): void {
  const view = artifactView(type, id)
  if (!isSidepanelOverlay) {
    openViewWindow(view)
    return
  }
  if (type === 'conversation') {
    GlobalEvents.emit('openChat:assistant', id)
    return
  }
  GlobalEvents.emit('sidepanel:openView', view)
}
